module.exports = "mutation DeleteContact($id: ID!) {\n  deleteContact(id: $id) {\n    deleted\n  }\n}\n"